__turbopack_context__.v({
  "badge": "button-module__6tk32G__badge",
  "badgeCount": "button-module__6tk32G__badgeCount",
  "dark": "button-module__6tk32G__dark",
  "ghost": "button-module__6tk32G__ghost",
  "inner": "button-module__6tk32G__inner",
  "label": "button-module__6tk32G__label",
  "primary": "button-module__6tk32G__primary",
  "root": "button-module__6tk32G__root",
  "secondary": "button-module__6tk32G__secondary",
  "section": "button-module__6tk32G__section",
  "sizeLg": "button-module__6tk32G__sizeLg",
  "sizeMd": "button-module__6tk32G__sizeMd",
  "sizeSm": "button-module__6tk32G__sizeSm",
  "skeleton": "button-module__6tk32G__skeleton",
  "skeletonLg": "button-module__6tk32G__skeletonLg",
  "skeletonMd": "button-module__6tk32G__skeletonMd",
  "skeletonSm": "button-module__6tk32G__skeletonSm",
  "wrapper": "button-module__6tk32G__wrapper",
});
